import * as React from "react";

export class EventCardSectionItem extends React.PureComponent < {
    content : string,
    className?: string
}, {} > {

    render() {
        return (
            <div className={`rj-ev-list__ev-card__section-item ${this.props.className || ""}`} data-uat="div-ev-list-ev-card-section-item">
                {this.props.content}
            </div>
        )
    }
}